import Vue from 'vue';
import VueRouter from 'vue-router';
import cookieUtils from '@/lib/cookieUtils'
import CompanyDto from '@/models/Companies/CompanyDto';
import BookingDto from '@/models/Bookings/BookingDto';
import { AppModule } from '@/store/modules/app';

//Shared Scope
import Login from '@/views/Auth/Login.vue';
import ResetPassword from '@/views/Auth/ResetPassword.vue';
import PrepareForLaunch from '@/components/Shared/PrepareForLaunch.vue'
import Sso from '@/views/Auth/Sso.vue';

//SysAdmin Scope
import SysAdminAgencies from '@/views/SysAdmin/Agencies.vue';
import SysAdminAgency from '@/views/SysAdmin/Agency.vue';
import SysAdminSysAdminUsers from '@/views/SysAdmin/SysAdminUsers.vue';
import SysAdminWorkerUsers from '@/views/SysAdmin/WorkerUsers.vue';
import SysAdminApps from '@/views/SysAdmin/Apps.vue';
import SysAdminTableOfContentsList from '@/views/SysAdmin/TableOfContentsList.vue';
import SysAdminTableOfContents from '@/views/SysAdmin/TableOfContentsDetails.vue';
import SysAdminKnowledgeBase from '@/views/SysAdmin/KnowledgeBase.vue';
import SysAdminKBContent from '@/views/SysAdmin/KBContent.vue';
import SysAdminMediaGallery from '@/views/SysAdmin/MediaGallery.vue';
import SysAdminAgenticTasks from '@/views/SysAdmin/AgenticTasks.vue';
import SysAdminMigrations from '@/views/SysAdmin/Migrations.vue';

//Agency Scope
import AgencyDashboard from '@/views/Agencies/Dashboard.vue';
import AgencyCompanies from '@/views/Agencies/Companies.vue';
import AgencyCompany from '@/views/Agencies/Company.vue';
import AgencyLocations from '@/views/Agencies/Locations.vue';
import AgencyLocation from '@/views/Agencies/Location.vue';
import AgencyContacts from '@/views/Agencies/Contacts.vue';
import AgencyContact from '@/views/Agencies/Contact.vue';
import AgencyActivities from '@/views/Agencies/Activities.vue';
import AgencyActivityDetails from '@/views/Agencies/ActivityDetails.vue';
import AgencyWorkers from '@/views/Agencies/Workers.vue';
import AgencyWorker from '@/views/Agencies/Worker.vue';
import AgencyWorkerWizard from '@/views/Agencies/WorkerWizard.vue';
import AgencyReports from '@/views/Agencies/Reports.vue';
import AgencyBookings from '@/views/Agencies/Bookings.vue';
import AgencyBooking from '@/views/Agencies/Booking.vue';
import AgencyBookingWizard from '@/views/Agencies/BookingWizard.vue';
import AgencyInvoices from '@/views/Agencies/Invoices.vue';
import AgencyInvoice from '@/views/Agencies/Invoice.vue';
import AgencyJobs from '@/views/Agencies/Jobs.vue';
import AgencyJob from '@/views/Agencies/Job.vue';
import AgencyOpportunities from '@/views/Agencies/Opportunities.vue';
import AgencyOpportunity from '@/views/Agencies/Opportunity.vue';
import AgencyPayrollRuns from '@/views/Agencies/PayrollRuns.vue';
import AgencyPayrollRun from '@/views/Agencies/PayrollRun.vue';
import AgencyInactivityReports from '@/views/Agencies/Reports/Inactivity.vue';
import AgencyCampaigns from '@/views/Agencies/Campaigns.vue';
import AgencyCampaign from '@/views/Agencies/Campaign.vue';
import AgencySpecOuts from '@/views/Agencies/SpecOuts.vue';
import AgencySpecOut from '@/views/Agencies/SpecOut.vue';
import AgencyTimesheets from '@/views/Agencies/Timesheets.vue';
import AgencyCompliance from '@/views/Agencies/Compliance.vue';
import AgencyIndex from '@/views/Agencies/Index.vue';
import AgencyUserProfile from '@/views/Agencies/UserProfile.vue';
import AgencyMessaging from '@/views/Agencies/Messaging.vue';
import AgencySettings from '@/views/Agencies/Settings.vue';
import AgencyProfileSettings from '@/views/Agencies/AgencyProfileSettings.vue';
import AppSettings from '@/views/Agencies/AppSettings.vue';
import AgencyUserSettings from '@/views/Agencies/UserSettings.vue';
import AgencyUserDetail from '@/views/Agencies/AgencyUserDetail.vue';
import AgencyGroupSettings from '@/views/Agencies/GroupSettings.vue';
import AgencyBranchSettings from '@/views/Agencies/BranchSettings.vue';
import AgencyBusinessHoursSettings from '@/views/Agencies/BusinessHoursSettings.vue';
import AgencyFaqSettings from '@/views/Agencies/FaqSettings.vue';
import AgencyConversationTopicSettings from '@/views/Agencies/ConversationTopicSettings.vue';
import AgencyRateCardSettings from '@/views/Agencies/RateCardSettings.vue';
import AgencyIndustrySettings from '@/views/Agencies/IndustrySettings.vue';
import AgencyLocationTypeSettings from '@/views/Agencies/LocationTypeSettings.vue';
import AgencyOpportunitySourceSettings from '@/views/Agencies/OpportunitySourceSettings.vue';
import AgencyOpportunityLostReasonSettings from '@/views/Agencies/OpportunityLostReasonSettings.vue';
import AgencyUniformSettings from '@/views/Agencies/UniformSettings.vue';
import AgencyQualificationSettings from '@/views/Agencies/QualificationSettings.vue';
import AgencySkillSettings from '@/views/Agencies/SkillSettings.vue';
import AgencyRoleSettings from '@/views/Agencies/AgencyRoleSettings.vue';
import AgencyReportingPeriodSettings from '@/views/Agencies/ReportingPeriodSettings.vue';
import AgencyKpiSettings from '@/views/Agencies/KpiSettings.vue';
import AgencyPositionSettings from '@/views/Agencies/PositionSettings.vue';
import AgencyEmailTemplateSettings from '@/views/Agencies/EmailTemplateSettings.vue';
import AgencyNoteCategorySettings from '@/views/Agencies/NoteCategorySettings.vue';
import AgencyActivityCategorySettings from '@/views/Agencies/ActivityCategorySettings.vue';
import AgencyIntegrationSettings from '@/views/Agencies/IntegrationSettings.vue';
import AgencyIntegration from '@/views/Agencies/Integration.vue';
import AgencyXeroAuthCallback from '@/views/Agencies/XeroAuthCallback.vue';
import MailboxCallback from '@/components/Settings/MailboxCallback.vue';
import AgencyKnowledgeBase from '@/views/Agencies/KnowledgeBase.vue';
import AgencyKBArticle from '@/views/Agencies/KBArticle.vue';
import CVParserTest from '@/views/Agencies/CVParserTest.vue';

//Company Scope
// import CompanyBookings from '@/views/Companies/Bookings.vue';
// import CompanyBooking from '@/views/Companies/Booking.vue';
// import CompanyNewBooking from '@/views/Companies/NewBooking.vue';
// import CompanyLocations from '@/views/Agencies/Locations.vue';
//import CompanyLocation from '@/views/Companies/Location.vue';
// import CompanyTimesheets from '@/views/Companies/Timesheets.vue';
// import CompanyReports from '@/views/Companies/Reports.vue';
// import CompanySettings from '@/views/Companies/Settings.vue';
// import CompanyUserProfile from '@/views/Companies/UserProfile.vue';

//Worker Scope
import WorkerBookingOffer from '@/views/Workers/BookingOffer.vue';
import WorkerBookingConfirm from '@/views/Workers/BookingConfirmation.vue';
import WorkerJobInvite from '@/views/Workers/JobInvite.vue';
import WorkerInterviewConfirm from '@/views/Workers/InterviewConfirmation.vue';
import WorkerJobOfferAcceptance from '@/views/Workers/JobOfferAcceptance.vue';
import WorkerMarketingOptOut from '@/views/Workers/MarketingOptOut.vue';
import WorkerError from '@/views/Workers/Error.vue';

//Contact Scope
import ContactInterviewConfirm from '@/views/Contacts/InterviewConfirmation.vue';
import ContactOfferConfirm from '@/views/Contacts/JobOfferConfirmation.vue';
import ContactMarketingOptOut from '@/views/Contacts/MarketingOptOut.vue';
import ContactError from '@/views/Contacts/Error.vue';

import AgencyPicker from '@/views/Auth/AgencyPicker.vue';

import PageNames from '@/router/PageNames';
import UserType from '@/models/Users/UserType';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import { AgencyModule } from '@/store/modules/agency';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
// import { CompanyListModule } from '@/store/modules/companyList';
// import { CompanyDetailsModule } from '@/store/modules/companyDetails';
// import { ContactListModule } from '@/store/modules/contactList';
import { ContactDetailsModule } from '@/store/modules/contactDetails';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import { LocationListModule } from '@/store/modules/locationList';
import { WorkerListModule } from '@/store/modules/workerList';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import { BookingListModule } from '@/store/modules/bookingList';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import { InvoiceListModule } from '@/store/modules/invoiceList';
import WorkerDto from '@/models/Workers/WorkerDto';
import ContactDto from '@/models/Contacts/ContactDto';
import WorkerQualificationDto from '@/models/WorkerQualifications/WorkerQualificationDto';
import LocationDto from '@/models/Locations/LocationDto';
import { AgencyDashboardModule } from '@/store/modules/agencyDashboard';
import AnonAuthenticateRequest from '@/models/Auth/AnonAuthenticateRequest';
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { ContactAnonModule } from '@/store/modules/contactAnon';
import { CompanyDetailsModule } from '@/store/modules/companyDetails';
import FilterBookingRoleStatisticsRequest from '@/models/BookingRoles/FilterBookingRoleStatisticsRequest';
import { WorkerWizardModule } from '@/store/modules/workerWizard';
import { CompanyListModule } from '@/store/modules/companyList';
import { ContactListModule } from '@/store/modules/contactList';
import { ReportsModule } from '@/store/modules/reports';
import { TimesheetListModule } from '@/store/modules/timesheetList';
import { ComplianceModule } from '@/store/modules/compliance';
import ajax from '@/lib/ajax';
import { AgencyScheduleModule } from '@/store/modules/agencySchedule';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import { JobListModule } from '@/store/modules/jobList';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import { CampaignListModule } from '@/store/modules/campaignList';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import { SpecOutListModule } from '@/store/modules/specOutList';
import { SysModule } from '@/store/modules/sys';
import { MessagingModule } from '@/store/modules/messaging';
import { SysKBContentListModule } from '@/store/modules/sysKBContentList';
import { cleanAllAgencyScopedStores } from '@/lib/storeCleanup';
import FirebaseAuthHandler from '@/views/Auth/FirebaseAuthHandler.vue';
import Axios from 'axios';

Vue.use(VueRouter);

const routes = [
  //Shared Scope
  {
    path: '/auth-handler',
    name: PageNames.AuthHandler,
    meta: { layout: 'logged-out' },
    component: FirebaseAuthHandler,
  },
  {
    path: '/login',
    name: PageNames.Login,
    meta: { layout: 'logged-out' },
    component: Login,
  },
  {
    path: '/reset',
    name: PageNames.ResetPassword,
    meta: { layout: 'logged-out' },
    component: ResetPassword,
  },
  {
    path: '/sso',
    name: PageNames.Sso,
    meta: { layout: 'blank' },
    component: Sso,
  },
  {
    path: '/auth/callback',
    name: PageNames.EntraCallback,
    meta: { layout: 'logged-out' },
    component: () => import('@/views/Auth/EntraCallback.vue'),
  },
  {
    path: '/agencypicker',
    name: PageNames.AgencyPicker,
    meta: { layout: 'logged-out' },
    component: AgencyPicker,
  },
  //SysAdmin Scope
  {
    path: '/sysadmin/sys-admin-users',
    name: PageNames.SysAdminSysAdminUsers,
    meta: { layout: 'logged-in' },
    component: SysAdminSysAdminUsers,
  },
  {
    path: '/sysadmin/worker-users',
    name: PageNames.SysAdminWorkerUsers,
    meta: { layout: 'logged-in' },
    component: SysAdminWorkerUsers,
  },
    {
    path: '/sysadmin/apps',
    name: PageNames.SysAdminApps,
    meta: { layout: 'logged-in' },
    component: SysAdminApps,
  },
  {
    path: '/sysadmin/agencies',
    name: PageNames.SysAdminAgencies,
    meta: { layout: 'logged-in' },
    component: SysAdminAgencies,
  },
  {
    path: '/sysadmin/agencies/:agencyid',
    name: PageNames.SysAdminAgencyDetails,
    meta: { layout: 'logged-in' },
    component: SysAdminAgency,
  },
  {
    path: '/sysadmin/table-of-contents',
    name: PageNames.SysAdminTableOfContentsList,
    meta: { layout: 'logged-in' },
    component: SysAdminTableOfContentsList,
  },
  {
    path: '/sysadmin/table-of-contents/:id',
    name: PageNames.SysAdminTableOfContents,
    meta: { layout: 'logged-in' },
    component: SysAdminTableOfContents,
  },
  {
    path: '/sysadmin/knowledge-base',
    name: PageNames.SysAdminKnowledgeBase,
    meta: { layout: 'logged-in' },
    component: SysAdminKnowledgeBase,
  },
  {
    path: '/sysadmin/knowledge-base/:contentid',
    name: PageNames.SysAdminKBContent,
    meta: { layout: 'logged-in' },
    component: SysAdminKBContent,
  },
  {
    path: '/sysadmin/media-gallery',
    name: PageNames.SysAdminMediaGallery,
    meta: { layout: 'logged-in' },
    component: SysAdminMediaGallery,
  },
  {
    path: '/sysadmin/agentic-tasks',
    name: PageNames.SysAdminAgenticTasks,
    meta: { layout: 'logged-in' },
    component: SysAdminAgenticTasks,
  },
  {
    path: '/sysadmin/migrations',
    name: PageNames.SysAdminMigrations,
    meta: { layout: 'logged-in' },
    component: SysAdminMigrations,
  },
  //Agency Scope
  {
    path: '/agency/dashboard',
    name: PageNames.AgencyDashboard,
    meta: { layout: 'logged-in' },
    component: AgencyDashboard,
  },
  {
    path: '/agency/companies',
    name: PageNames.AgencyCompanies,
    meta: { layout: 'logged-in' },
    component: AgencyCompanies,
  },
  {
    path: '/agency/companies/:companyid',
    name: PageNames.AgencyCompanyDetails,
    meta: { layout: 'logged-in' },
    component: AgencyCompany,
  },
  {
    path: '/agency/locations',
    name: PageNames.AgencyLocations,
    meta: { layout: 'logged-in' },
    component: AgencyLocations,
  },
  {
    path: '/agency/locations/:locationid',
    name: PageNames.AgencyLocationDetails,
    meta: { layout: 'logged-in' },
    component: AgencyLocation,
  },
  {
    path: '/agency/contacts',
    name: PageNames.AgencyContacts,
    meta: { layout: 'logged-in' },
    component: AgencyContacts,
  },
  {
    path: '/agency/contacts/:contactid',
    name: PageNames.AgencyContactDetails,
    meta: { layout: 'logged-in' },
    component: AgencyContact,
  },
  {
    path: '/agency/activities',
    name: PageNames.AgencyActivities,
    meta: { layout: 'logged-in' },
    component: AgencyActivities,
  },
  {
    path: '/agency/activities/:activityid',
    name: PageNames.AgencyActivityDetails,
    meta: { layout: 'logged-in' },
    component: AgencyActivityDetails,
  },
  {
    path: '/agency/workers',
    name: PageNames.AgencyWorkers,
    meta: { layout: 'logged-in' },
    component: AgencyWorkers,
  },
  {
    path: '/agency/workers/:workerid',
    name: PageNames.AgencyWorkerDetails,
    meta: { layout: 'logged-in' },
    component: AgencyWorker,
  },
  {
    path: '/agency/workerwizard',
    name: PageNames.AgencyWorkerWizard,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyWorkerWizard,
  },
  {
    path: '/agency/bookings',
    name: PageNames.AgencyBookings,
    meta: { layout: 'logged-in' },
    component: AgencyBookings,
  },
  {
    path: '/agency/bookings/:bookingid',
    name: PageNames.AgencyBookingDetails,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyBooking,
  },
  {
    path: '/agency/invoices',
    name: PageNames.AgencyInvoices,
    meta: { layout: 'logged-in' },
    component: AgencyInvoices,
  },
  {
    path: '/agency/invoices/:invoiceid',
    name: PageNames.AgencyInvoiceDetails,
    meta: { layout: 'logged-in' },
    component: AgencyInvoice,
  },
  {
    path: '/agency/companies/:companyid/bookingwizard',
    name: PageNames.AgencyBookingWizard,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyBookingWizard,
  },
  {
    path: '/agency/jobs',
    name: PageNames.AgencyJobs,
    meta: { layout: 'logged-in' },
    component: AgencyJobs,
  },
  {
    path: '/agency/jobs/:jobid',
    name: PageNames.AgencyJobDetails,
    meta: { layout: 'logged-in' },
    component: AgencyJob,
  },
  {
    path: '/agency/opportunities',
    name: PageNames.AgencyOpportunities,
    meta: { layout: 'logged-in' },
    component: AgencyOpportunities,
  },
  {
    path: '/agency/opportunities/:opportunityId',
    name: PageNames.AgencyOpportunityDetails,
    meta: { layout: 'logged-in' },
    component: AgencyOpportunity,
  },
  {
    path: '/agency/payroll',
    name: PageNames.AgencyPayrollRuns,
    meta: { layout: 'logged-in' },
    component: AgencyPayrollRuns,
  },
  {
    path: '/agency/payroll/:payrollRunId',
    name: PageNames.AgencyPayrollRunDetails,
    meta: { layout: 'logged-in' },
    component: AgencyPayrollRun,
  },
  {
    path: '/agency/reports/inactivity',
    name: PageNames.AgencyInactivityReports,
    meta: { layout: 'logged-in' },
    component: AgencyInactivityReports,
  },
  {
    path: '/agency/campaigns',
    name: PageNames.AgencyCampaigns,
    meta: { layout: 'logged-in' },
    component: AgencyCampaigns,
  },
  {
    path: '/agency/campaigns/:campaignid',
    name: PageNames.AgencyCampaignDetails,
    meta: { layout: 'logged-in' },
    component: AgencyCampaign,
  },
  {
    path: '/agency/spec-outs',
    name: PageNames.AgencySpecOuts,
    meta: { layout: 'logged-in' },
    component: AgencySpecOuts,
  },
  {
    path: '/agency/spec-outs/:specoutid',
    name: PageNames.AgencySpecOutDetails,
    meta: { layout: 'logged-in' },
    component: AgencySpecOut,
  },
  {
    path: '/agency/timesheets',
    name: PageNames.AgencyTimesheets,
    meta: { layout: 'logged-in' },
    component: AgencyTimesheets,
  },
  // {
  //   path: '/agency/reports',
  //   name: PageNames.AgencyReports,
  //   meta: { layout: 'logged-in' },
  //   component: PrepareForLaunch,
  // },
    {
    path: '/agency/reports',
    name: PageNames.AgencyReports,
    meta: { layout: 'logged-in' },
    component: AgencyReports,
  },
  {
    path: '/agency/compliance',
    name: PageNames.AgencyCompliance,
    meta: { layout: 'logged-in' },
    component: AgencyCompliance,
  },
  {
    path: '/agency/index',
    name: PageNames.AgencyIndex,
    meta: { layout: 'logged-in' },
    component: AgencyIndex,
  },
  {
    path: '/agency/knowledge-base',
    name: PageNames.AgencyKnowledgeBase,
    meta: { layout: 'kb' },
    component: AgencyKnowledgeBase,
  },
  {
    path: '/agency/knowledge-base/:slug',
    name: PageNames.AgencyKBArticle,
    meta: { layout: 'kb' },
    component: AgencyKBArticle,
  },
  {
    path: '/agency/test/cv-parser',
    name: PageNames.AgencyCVParserTest,
    meta: { layout: 'logged-in' },
    component: CVParserTest,
  },
  {
    path: '/agency/userprofile',
    name: PageNames.AgencyUserProfile,
    meta: { layout: 'logged-in' },
    component: AgencyUserProfile,
  },
  {
    path: '/agency/messaging',
    name: PageNames.AgencyMessaging,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyMessaging,
  },
  {
    path: '/agency/settings',
    name: PageNames.AgencySettings,
    meta: { layout: 'logged-in' },
    component: AgencySettings,
  },
  {
    path: '/agency/settings/profile',
    name: PageNames.AgencyProfileSettings,
    meta: { layout: 'logged-in' },
    component: AgencyProfileSettings,
  },
  {
    path: '/agency/settings/app',
    name: PageNames.AgencyAppSettings,
    meta: { layout: 'logged-in' },
    component: AppSettings,
  },
  {
    path: '/agency/settings/users',
    name: PageNames.AgencyUserSettings,
    meta: { layout: 'logged-in' },
    component: AgencyUserSettings,
  },
  {
    path: '/agency/settings/users/:userid',
    name: PageNames.AgencyUserDetails,
    meta: { layout: 'logged-in' },
    component: AgencyUserDetail,
  },
  {
    path: '/agency/settings/groups',
    name: PageNames.AgencyGroupSettings,
    meta: { layout: 'logged-in' },
    component: AgencyGroupSettings,
  },
  {
    path: '/agency/settings/branches',
    name: PageNames.AgencyBranchSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyBranchSettings,
  },
  {
    path: '/agency/settings/business-hours',
    name: PageNames.AgencyBusinessHoursSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyBusinessHoursSettings,
  },
  {
    path: '/agency/settings/email-templates',
    name: PageNames.AgencyEmailTemplateSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyEmailTemplateSettings,
  },
  {
    path: '/agency/settings/note-categories',
    name: PageNames.AgencyNoteCategorySettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyNoteCategorySettings,
  },
  {
    path: '/agency/settings/activity-categories',
    name: PageNames.AgencyActivityCategorySettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyActivityCategorySettings,
  },
  {
    path: '/agency/settings/integrations/:integrationid',
    name: PageNames.AgencyIntegrationDetails,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyIntegration,
  },
  {
    path: '/agency/settings/integrations',
    name: PageNames.AgencyIntegrationSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyIntegrationSettings,
  },
  {
    path: '/agency/settings/faqs',
    name: PageNames.AgencyFaqSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyFaqSettings,
  },
  {
    path: '/agency/settings/conversation-topics',
    name: PageNames.AgencyConversationTopicSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyConversationTopicSettings,
  },
  {
    path: '/agency/settings/industries',
    name: PageNames.AgencyIndustrySettings,
    meta: { layout: 'logged-in' },
    component: AgencyIndustrySettings,
  },
  {
    path: '/agency/settings/rate-cards',
    name: PageNames.AgencyRateCardSettings,
    meta: { layout: 'logged-in' },
    component: AgencyRateCardSettings,
  },
  {
    path: '/agency/settings/locationTypes',
    name: PageNames.AgencyLocationTypeSettings,
    meta: { layout: 'logged-in' },
    component: AgencyLocationTypeSettings,
  },
  {
    path: '/agency/settings/opportunitySources',
    name: PageNames.AgencyOpportunitySourceSettings,
    meta: { layout: 'logged-in' },
    component: AgencyOpportunitySourceSettings,
  },
  {
    path: '/agency/settings/opportunityLostReasons',
    name: PageNames.AgencyOpportunityLostReasonSettings,
    meta: { layout: 'logged-in' },
    component: AgencyOpportunityLostReasonSettings,
  },
  {
    path: '/agency/settings/uniforms',
    name: PageNames.AgencyUniformSettings,
    meta: { layout: 'logged-in' },
    component: AgencyUniformSettings,
  },
  {
    path: '/agency/settings/qualifications',
    name: PageNames.AgencyQualificationSettings,
    meta: { layout: 'logged-in' },
    component: AgencyQualificationSettings,
  },
  {
    path: '/agency/settings/skills',
    name: PageNames.AgencySkillSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencySkillSettings,
  },
  {
    path: '/agency/settings/roles',
    name: PageNames.AgencyRoleSettings,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyRoleSettings,
  },
  {
    path: '/agency/settings/reporting-periods',
    name: PageNames.AgencyReportingPeriodSettings,
    meta: { layout: 'logged-in' },
    component: AgencyReportingPeriodSettings,
  },
  {
    path: '/agency/settings/kpis',
    name: PageNames.AgencyKpiSettings,
    meta: { layout: 'logged-in' },
    component: AgencyKpiSettings,
  },
  {
    path: '/agency/settings/positions',
    name: PageNames.AgencyPositionSettings,
    meta: { layout: 'logged-in' },
    component: AgencyPositionSettings,
  },
  {
    path: '/agency/xero/callback',
    name: PageNames.AgencyXeroAuthCallback,
    meta: { layout: 'logged-in-non-scrolly' },
    component: AgencyXeroAuthCallback,
  },
  {
    path: '/agency/userprofile/mailbox-callback',
    name: PageNames.AgencyMailboxCallback,
    meta: { layout: 'logged-in' },
    component: MailboxCallback,
  },
  // //Company Scope
  // {
  //   path: '/companies/:companyid/bookings',
  //   name: PageNames.CompanyBookings,
  //   meta: { layout: 'logged-in' },
  //   component: CompanyBookings,
  // },
  // {
  //   path: '/companies/:companyid/bookings/:bookingid',
  //   name: PageNames.CompanyBookingDetails,
  //   meta: { layout: 'logged-in' },
  //   component: CompanyBooking,
  // },
  // {
  //   path: '/companies/:companyid/newbooking',
  //   name: PageNames.CompanyNewBooking,
  //   meta: { layout: 'logged-in' },
  //   component: CompanyNewBooking,
  // },
  // {
  //   path: '/companies/:companyid/locations',
  //   name: PageNames.CompanyLocations,
  //   meta: { layout: 'logged-in' },
  //   component: CompanyLocations,
  // },
  // {
  //   path: '/companies/:companyid/timesheets',
  //   name: PageNames.CompanyTimesheets,
  //   meta: { layout: 'logged-in' },
  //   component: PrepareForLaunch,
  // },
  // {
  //   path: '/companies/:companyid/reports',
  //   name: PageNames.CompanyReports,
  //   meta: { layout: 'logged-in' },
  //   component: PrepareForLaunch,
  // },
  // {
  //   path: '/companies/:companyid/settings',
  //   name: PageNames.CompanySettings,
  //   meta: { layout: 'logged-in' },
  //   component: CompanySettings,
  // },
  // {
  //   path: '/companies/:companyid/userprofile',
  //   name: PageNames.CompanyUserProfile,
  //   meta: { layout: 'logged-in' },
  //   component: CompanyUserProfile,
  // },
  //Candidate Scope - backwards compatibility after rename
  {
    path: '/candidates/:agencyid/offer/:bookingroleworkerid',
    name: PageNames.CandidateBookingOfferOld,
    meta: { layout: 'anon' },
    component: WorkerBookingOffer,
  },
  {
    path: '/candidates/:agencyid/confirmation/:bookingroleworkerid',
    name: PageNames.CandidateBookingConfirmOld,
    meta: { layout: 'anon' },
    component: WorkerBookingConfirm,
  },
  {
    path: '/candidates/:agencyid/bookingoffers/:bookingroleworkerid',
    name: PageNames.CandidateBookingOffer,
    meta: { layout: 'anon' },
    component: WorkerBookingOffer,
  },
  {
    path: '/candidates/:agencyid/bookingconfirmations/:bookingroleworkerid',
    name: PageNames.CandidateBookingConfirm,
    meta: { layout: 'anon' },
    component: WorkerBookingConfirm,
  },
  {
    path: '/candidates/:agencyid/jobinvites/:jobworkerid',
    name: PageNames.CandidateJobInvite,
    meta: { layout: 'anon' },
    component: WorkerJobInvite,
  },
  {
    path: '/candidates/:agencyid/jobinterviews/:jobworkerinterviewid',
    name: PageNames.CandidateInterviewConfirm,
    meta: { layout: 'anon' },
    component: WorkerInterviewConfirm,
  },
  {
    path: '/candidates/:agencyid/joboffers/:jobworkerofferid',
    name: PageNames.CandidateOfferAccept,
    meta: { layout: 'anon' },
    component: WorkerJobOfferAcceptance,
  },
  {
    path: '/candidates/:agencyid/marketingoptout/:workerid',
    name: PageNames.CandidateMarketingOptOut,
    meta: { layout: 'anon' },
    component: WorkerMarketingOptOut,
  },
  {
    path: '/candidates/error',
    name: PageNames.CandidateError,
    meta: { layout: 'anon' },
    component: WorkerError,
  },
  //Worker Scope - the first two can be deleted after 
  //the new paths have been live for a few weeks
  {
    path: '/workers/:agencyid/offer/:bookingroleworkerid',
    name: PageNames.WorkerBookingOfferOld,
    meta: { layout: 'anon' },
    component: WorkerBookingOffer,
  },
  {
    path: '/workers/:agencyid/confirmation/:bookingroleworkerid',
    name: PageNames.WorkerBookingConfirmOld,
    meta: { layout: 'anon' },
    component: WorkerBookingConfirm,
  },
  {
    path: '/workers/:agencyid/bookingoffers/:bookingroleworkerid',
    name: PageNames.WorkerBookingOffer,
    meta: { layout: 'anon' },
    component: WorkerBookingOffer,
  },
  {
    path: '/workers/:agencyid/bookingconfirmations/:bookingroleworkerid',
    name: PageNames.WorkerBookingConfirm,
    meta: { layout: 'anon' },
    component: WorkerBookingConfirm,
  },
  {
    path: '/workers/:agencyid/jobinvites/:jobworkerid',
    name: PageNames.WorkerJobInvite,
    meta: { layout: 'anon' },
    component: WorkerJobInvite,
  },
  {
    path: '/workers/:agencyid/jobinterviews/:jobworkerinterviewid',
    name: PageNames.WorkerInterviewConfirm,
    meta: { layout: 'anon' },
    component: WorkerInterviewConfirm,
  },
  {
    path: '/workers/:agencyid/joboffers/:jobworkerofferid',
    name: PageNames.WorkerOfferAccept,
    meta: { layout: 'anon' },
    component: WorkerJobOfferAcceptance,
  },
  {
    path: '/workers/:agencyid/marketingoptout/:workerid',
    name: PageNames.WorkerMarketingOptOut,
    meta: { layout: 'anon' },
    component: WorkerMarketingOptOut,
  },
  {
    path: '/workers/error',
    name: PageNames.WorkerError,
    meta: { layout: 'anon' },
    component: WorkerError,
  },
  //Contacts Scope
  {
    path: '/contacts/:agencyid/jobinterviews/:jobworkerinterviewid',
    name: PageNames.ContactInterviewConfirm,
    meta: { layout: 'anon' },
    component: ContactInterviewConfirm,
  },
  {
    path: '/contacts/:agencyid/joboffers/:jobworkerofferid',
    name: PageNames.ContactOfferConfirm,
    meta: { layout: 'anon' },
    component: ContactOfferConfirm,
  },
  {
    path: '/contacts/:agencyid/marketingoptout/:contactid',
    name: PageNames.ContactMarketingOptOut,
    meta: { layout: 'anon' },
    component: ContactMarketingOptOut,
  },
  {
    path: '/opportunities/:agencyid/marketingoptout/:opportunityid',
    name: PageNames.OpportunityMarketingOptOut,
    meta: { layout: 'anon' },
    component: ContactMarketingOptOut,
  },
  {
    path: '/contacts/error',
    name: PageNames.ContactError,
    meta: { layout: 'anon' },
    component: ContactError,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  console.log("Navigating to " + to.name);

  await AppModule.clearErrorMessage();
  
  if (from.name === PageNames.Login && to.name === PageNames.AgencyPicker) {
    return next();
  }
  if (to.name === PageNames.Login || to.name === PageNames.ResetPassword) {
    console.log("Cleaning App State");
    cleanAllAgencyScopedStores();
    AppModule.cleanState();
    return next();
  }
  console.log("navigating to = " + to.name)
  const publicPages = [
    PageNames.AuthHandler.toString(),
    PageNames.Login.toString(),
    PageNames.ResetPassword.toString(),
    PageNames.EntraCallback.toString(), 
    PageNames.WorkerBookingOffer.toString(),
    PageNames.WorkerBookingConfirm.toString(), 
    PageNames.WorkerBookingOfferOld.toString(),
    PageNames.WorkerBookingConfirmOld.toString(), 
    PageNames.WorkerJobInvite.toString(), 
    PageNames.WorkerInterviewConfirm.toString(), 
    PageNames.WorkerOfferAccept.toString(), 
    PageNames.WorkerError.toString(), 
    PageNames.CandidateBookingOffer.toString(), 
    PageNames.CandidateBookingConfirm.toString(), 
    PageNames.CandidateBookingOfferOld.toString(),
    PageNames.CandidateBookingConfirmOld.toString(), 
    PageNames.CandidateJobInvite.toString(), 
    PageNames.CandidateInterviewConfirm.toString(), 
    PageNames.CandidateOfferAccept.toString(), 
    PageNames.CandidateMarketingOptOut.toString(), 
    PageNames.CandidateError.toString(),
    PageNames.ContactInterviewConfirm.toString(),
    PageNames.ContactOfferConfirm.toString(),
    PageNames.ContactError.toString(),
    PageNames.ContactMarketingOptOut.toString(),
    PageNames.OpportunityMarketingOptOut.toString()];
  const authRequired = !publicPages.includes(to.name);
  console.log("auth required = " + authRequired)
  //const loggedIn = cookieUtils.getToken();
  const loggedIn = AppModule.currentUser !== null
  console.log("logged in = " + loggedIn)
  if (to.name == PageNames.AuthHandler) {
    return next();
  }
  if (authRequired && !loggedIn) {
    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  } else {
    if (to.path === "/") {
      return next({
        path:'/login',
      });
    }
    //For backwards compatibility after name change
    const candidatePages = [ 
      PageNames.CandidateBookingOffer.toString(), 
      PageNames.CandidateBookingConfirm.toString(), 
      PageNames.CandidateBookingOfferOld.toString(),
      PageNames.CandidateBookingConfirmOld.toString(), 
      PageNames.CandidateJobInvite.toString(), 
      PageNames.CandidateInterviewConfirm.toString(), 
      PageNames.CandidateOfferAccept.toString(), 
      PageNames.CandidateMarketingOptOut.toString(), 
      PageNames.CandidateError.toString() ];
    const candidateNavigationScope = candidatePages.includes(to.name);
    const workerPages = [ 
      PageNames.WorkerBookingOffer.toString(), 
      PageNames.WorkerBookingConfirm.toString(), 
      PageNames.WorkerBookingOfferOld.toString(),
      PageNames.WorkerBookingConfirmOld.toString(), 
      PageNames.WorkerJobInvite.toString(), 
      PageNames.WorkerInterviewConfirm.toString(), 
      PageNames.WorkerOfferAccept.toString(), 
      PageNames.WorkerMarketingOptOut.toString(), 
      PageNames.WorkerError.toString() ];
    const workerNavigationScope = workerPages.includes(to.name);
    const contactPages = [
      PageNames.ContactInterviewConfirm.toString(),
      PageNames.ContactOfferConfirm.toString(),
      PageNames.ContactMarketingOptOut.toString(),
      PageNames.OpportunityMarketingOptOut.toString(),
      PageNames.ContactError.toString() ];
    const contactNavigationScope = contactPages.includes(to.name);
    const sysAdminPages = [
      PageNames.SysAdminSysAdminUsers.toString(),
      PageNames.SysAdminWorkerUsers.toString(),
      PageNames.SysAdminApps.toString(),
      PageNames.SysAdminAgencies.toString(),
      PageNames.SysAdminAgencyDetails.toString(),
      PageNames.SysAdminTableOfContentsList.toString(),
      PageNames.SysAdminTableOfContents.toString(),
      PageNames.SysAdminKnowledgeBase.toString(),
      PageNames.SysAdminKBContent.toString(),
      PageNames.SysAdminMediaGallery.toString(),
      PageNames.SysAdminAgenticTasks.toString(),
      PageNames.SysAdminMigrations.toString()];
    const sysAdminNavigationScope = sysAdminPages.includes(to.name);
    const agencyPages = [ 
      PageNames.Sso.toString(), 
      PageNames.AgencyDashboard.toString(),
      PageNames.AgencyCompanies.toString(), 
      PageNames.AgencyCompanyDetails.toString(), 
      PageNames.AgencyContacts.toString(),
      PageNames.AgencyContactDetails.toString(),
      PageNames.AgencyActivities.toString(),
      PageNames.AgencyActivityDetails.toString(),
      PageNames.AgencyBookings.toString(), 
      PageNames.AgencyBookingWizard.toString(), 
      PageNames.AgencyBookingDetails.toString(), 
      PageNames.AgencyInvoices.toString(),
      PageNames.AgencyInvoiceDetails.toString(),
      PageNames.AgencyJobs.toString(),
      PageNames.AgencyJobDetails.toString(),
      PageNames.AgencyOpportunities.toString(),
      PageNames.AgencyOpportunityDetails.toString(),
      PageNames.AgencyPayrollRuns.toString(),
      PageNames.AgencyPayrollRunDetails.toString(),
      PageNames.AgencyInactivityReports.toString(),
      PageNames.AgencyCampaigns.toString(),
      PageNames.AgencyCampaignDetails.toString(),
      PageNames.AgencySpecOuts.toString(),
      PageNames.AgencySpecOutDetails.toString(),
      PageNames.AgencyCompliance.toString(), 
      PageNames.AgencyReports.toString(), 
      PageNames.AgencyIndex.toString(),
      PageNames.AgencyKnowledgeBase.toString(),
      PageNames.AgencyKBArticle.toString(),
      PageNames.AgencyCVParserTest.toString(),
      PageNames.AgencyUserProfile.toString(),
      PageNames.AgencyWorkers.toString(), 
      PageNames.AgencyWorkerDetails.toString(),
      PageNames.AgencyWorkerWizard.toString(), 
      PageNames.AgencyLocations.toString(), 
      PageNames.AgencyLocationDetails.toString(), 
      PageNames.AgencyTimesheets.toString(), 
      PageNames.AgencyMessaging.toString(), 
      PageNames.AgencySettings.toString(), 
      PageNames.AgencyProfileSettings.toString(), 
      PageNames.AgencyAppSettings.toString(),
      PageNames.AgencyUserSettings.toString(),
      PageNames.AgencyUserDetails.toString(),
      PageNames.AgencyGroupSettings.toString(),
      PageNames.AgencyBranchSettings.toString(),
      PageNames.AgencyEmailTemplateSettings.toString(),
      PageNames.AgencyNoteCategorySettings.toString(),
      PageNames.AgencyActivityCategorySettings.toString(),
      PageNames.AgencyIntegrationSettings.toString(),
      PageNames.AgencyIntegrationDetails.toString(),
      PageNames.AgencyBusinessHoursSettings.toString(),
      PageNames.AgencyFaqSettings.toString(),
      PageNames.AgencyConversationTopicSettings.toString(),
      PageNames.AgencyIndustrySettings.toString(),
      PageNames.AgencyLocationTypeSettings.toString(),
      PageNames.AgencyOpportunitySourceSettings.toString(),
      PageNames.AgencyOpportunityLostReasonSettings.toString(),
      PageNames.AgencyRateCardSettings.toString(),
      PageNames.AgencyUniformSettings.toString(),
      PageNames.AgencyQualificationSettings.toString(),
      PageNames.AgencySkillSettings.toString(),
      PageNames.AgencyRoleSettings.toString(),
      PageNames.AgencyReportingPeriodSettings.toString(),
      PageNames.AgencyKpiSettings.toString(),
      PageNames.AgencyPositionSettings.toString(),
      PageNames.AgencyXeroAuthCallback.toString(),
      PageNames.AgencyMailboxCallback.toString()];
    const agencyNavigationScope = agencyPages.includes(to.name);

    //const companyPages = [ PageNames.CompanyReports, PageNames.CompanyBookings.toString(), PageNames.CompanyBookingDetails, PageNames.CompanyNewBooking, PageNames.CompanySettings.toString(), PageNames.CompanyTimesheets.toString(), PageNames.CompanyUserProfile.toString(), PageNames.CompanyLocationDetails.toString(), PageNames.CompanyLocations.toString()];
    //const companyNavigationScope = companyPages.includes(to.name);

    // if (companyNavigationScope) {
    //   //If this is the first page to load we might need to load the current company 
    //   //and company menu as it won't have been loaded
    //   console.log("Company Navigation scope - current company : " + JSON.stringify(CompanyDetailsModule.currentCompany))
    //   const company: CompanyDto = new CompanyDto();
    //   company.id = to.params.companyid
    //   if (!CompanyDetailsModule.currentCompany.id) {
    //     await CompanyDetailsModule.getCompany(company);
    //   }
    //   await AppModule.setCompanyScope(company);
    //   //If we are navigating to a booking we need to load it and check worker search options are initialised
    //   if (to.name === PageNames.AgencyBookingDetails) {
    //     const booking: BookingDto = new BookingDto();
    //     booking.id = to.params.bookingid
    //     booking.location.companyId = to.params.companyid;
    //     await BookingDetailsModule.getBooking(booking)
    //     //await BookingDetailsModule.getWorkerSearchOptions();
    //   }
    //   //If we are navigating to the new booking page we need to reset the viewmodel
    //   if (to.name === PageNames.CompanyNewBooking) {
    //     await BookingWizardModule.getNewBookingOptions();
    //   }
    //   return next();
    // }
    if (agencyNavigationScope) {
      if (AppModule.userProfile.userType === UserType.Company) {
        return next({
          name: PageNames.Login.toString(),
        });
      } else {
        await AppModule.setAgencyScope();
        await AppModule.getUserProfile();
        await MessagingModule.getConversationTopics();
        if (to.name === PageNames.AgencyWorkers) {
          await WorkerListModule.getWorkerSearchOptions();
        } else if (to.name === PageNames.AgencyWorkerDetails) {
          const worker: WorkerDto = new WorkerDto();
          worker.id = to.params.workerid;
          await MessagingModule.cleanState(true);
          await WorkerDetailsModule.cleanState();
          await WorkerDetailsModule.getAgencyAttributes();
          await AgencySettingsModule.getBranches();
          await WorkerDetailsModule.getWorker(worker);
        } else if (to.name === PageNames.AgencyContactDetails) {
          const contact: ContactDto = new ContactDto();
          contact.id = to.params.contactid;
          await ContactDetailsModule.getContact(contact);
        } else if (to.name === PageNames.AgencyLocations) {
          await LocationListModule.getLocationSearchOptions(); 
        } else if (to.name === PageNames.AgencyCompanyDetails) {
          await AgencySettingsModule.getPositions();
          await AgencySettingsModule.getLocationTypes();
          const company: CompanyDto = new CompanyDto();
          company.id = to.params.companyid;
          await CompanyDetailsModule.getCompany(company);
          await CompanyDetailsModule.getLocationRateCards();
        } else if (to.name === PageNames.AgencyLocationDetails) {
          const location: LocationDto = new LocationDto();
          location.id = to.params.locationid;
          await LocationDetailsModule.getLocation(location);
          await LocationDetailsModule.getRateCards();
          await AgencySettingsModule.getLocationTypes();
        } else if (to.name === PageNames.AgencyBookingDetails) {
          await MessagingModule.cleanState(true);
          await BookingDetailsModule.cleanState();
          await BookingDetailsModule.getWorkerSearchOptions();
          const booking: BookingDto = new BookingDto();
          booking.id = to.params.bookingid;
          await BookingDetailsModule.getBooking(booking);
        } else if (to.name === PageNames.AgencyInvoiceDetails) {
          await InvoiceListModule.cleanState();
        } else if (to.name === PageNames.AgencyMessaging) {
          await MessagingModule.cleanState(true);
        } else if (to.name === PageNames.AgencySettings) {
          //await AgencyModule.getRateCards();
          //await AgencyModule.getPositions();
          //await AgencyModule.getSkills();
          //await AgencyModule.getQualifications();
          //await AgencyModule.getUniforms();
          //await AgencyModule.getAgencyUsers();
          //await AgencyModule.getIndustries();
          //await AgencyModule.getLocationTypes();
          //await AgencyModule.getDesks();
          //await AgencyModule.getBranches();
          //await AgencyModule.getForms();
        } else if (to.name === PageNames.AgencyUserDetails) {
          await AgencySettingsModule.getBranches();
          await AgencySettingsModule.getAgencyUsers();
          await AgencySettingsModule.getAgencyUser(to.params.userid);
        } else if (to.name === PageNames.AgencyCompliance) {
          await ComplianceModule.searchWorkerDocuments();
          await ComplianceModule.searchCompanyDocuments();
          await ComplianceModule.searchLocationDocuments();
        } else if (to.name === PageNames.AgencyBookingWizard) {
          await BookingWizardModule.getNewBookingOptions(to.params.companyid);
        } else if (to.name === PageNames.AgencyBookings) {
          await AgencySettingsModule.getBranches();
          await BookingListModule.getCompaniesForSearchOptions();
          await BookingListModule.getLocationsForSearchOptions();
        } else if (to.name === PageNames.AgencyInvoices) {
          await InvoiceListModule.getCompaniesForSearchOptions();
        } else if (to.name === PageNames.AgencyTimesheets) {
          await AgencySettingsModule.getBranches();
          await TimesheetListModule.getWorkersForSearchOptions();
          await TimesheetListModule.getCompaniesForSearchOptions();
          await TimesheetListModule.getLocationsForSearchOptions();
        } else if (to.name === PageNames.AgencyDashboard) {
          // await AgencyModule.getBranches();
          // await AgencyModule.getDesks();
          // await AgencyDashboardModule.getCompaniesForSearchOptions();
          // await AgencyDashboardModule.getLocationsForSearchOptions();
          // await AgencyDashboardModule.mapUserDefaults();
          // await AgencyDashboardModule.getBookingRoleStatistics();
        } else if (to.name === PageNames.Sso) {

          // Get the query string params we need
          const state = to.query.state;
          const nonce = to.query.nonce;
          await ajax.get("/api/v1/sso/freshdesk/jwt?state=" + state + "&nonce=" + nonce)
          .then(response => {
            window.location.href = response.data.redirect;
          })
          .catch(error => {
            AppModule.handleApiError(error);
            //this.setLoading(false);
          });
        }
        return next();
      }
    }
    if (sysAdminNavigationScope) {
      // console.log("Current User Profile: " + JSON.stringify(AppModule.userProfile));
      // console.log("Current User Type: " + AppModule.userProfile.userType);
      if (AppModule.userProfile.userType !== UserType.SysAdmin) {
        return next({
          name: PageNames.Login.toString(),
        });
      } else {
        //console.log("Setting sys admin scope");
        await AppModule.setSysAdminScope();
        return next();
      }
    }

    //For backwards compatibility after name change
    if (candidateNavigationScope) {
      if (to.name === PageNames.CandidateBookingOffer || to.name === PageNames.CandidateBookingOfferOld) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.getBookingOffer(to.params.bookingroleworkerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.CandidateBookingConfirm || to.name === PageNames.CandidateBookingConfirmOld) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.getBookingConfirmation(to.params.bookingroleworkerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.CandidateJobInvite) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        await WorkerAnonModule.getJobInvite(to.params.jobworkerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.CandidateInterviewConfirm) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        await WorkerAnonModule.getInterviewConfirmation(to.params.jobworkerinterviewid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.CandidateOfferAccept) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        await WorkerAnonModule.getOfferAcceptance(to.params.jobworkerofferid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.CandidateMarketingOptOut) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        await WorkerAnonModule.optOutOfMarketing(to.params.workerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.CandidateError.toString(),
          });
        }
        return next();
      }
      return next();
    }
    if (workerNavigationScope) {
      if (to.name === PageNames.WorkerBookingOffer || to.name === PageNames.WorkerBookingOfferOld) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.getBookingOffer(to.params.bookingroleworkerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.WorkerBookingConfirm || to.name === PageNames.WorkerBookingConfirmOld) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.getBookingConfirmation(to.params.bookingroleworkerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.WorkerJobInvite) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.getJobInvite(to.params.jobworkerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.WorkerInterviewConfirm) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.getInterviewConfirmation(to.params.jobworkerinterviewid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.WorkerOfferAccept) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.getOfferAcceptance(to.params.jobworkerofferid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.WorkerMarketingOptOut) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        await WorkerAnonModule.optOutOfMarketing(to.params.workerid);
        if (WorkerAnonModule.isError) {
          return next({
            name: PageNames.WorkerError.toString(),
          });
        }
        return next();
      }
      return next();
    }
    if (contactNavigationScope) {
      console.log("contact nav scope");
      if (to.name === PageNames.ContactMarketingOptOut) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        //This might be an opt out from a campaign - send that ID as well in the query string if needed
        let path = to.params.contactid;
        const campaignContactId = to.query.campaignContactId.toString();
        if (campaignContactId !== "") {
          path = path + "?campaignContactId=" + campaignContactId;
        }
        console.log("Opting out of marketing for contact: " + path);

        await ContactAnonModule.optOutOfMarketing(path);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.OpportunityMarketingOptOut) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        //This is an opt out from a campaign - send the campaign opportunity ID too if present
        let path = to.params.opportunityid;
        const campaignOpportunityId = (to.query.campaignOpportunityId || "").toString();
        if (campaignOpportunityId !== "") {
          path = path + "?campaignOpportunityId=" + campaignOpportunityId;
        }
        await ContactAnonModule.optOutOfMarketingOpportunity(path);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.ContactInterviewConfirm) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        await ContactAnonModule.getInterviewConfirmation(to.params.jobworkerinterviewid);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        return next();
      } else if (to.name === PageNames.ContactOfferConfirm) {
        const request = new AnonAuthenticateRequest();
        request.accessToken = to.query.accessToken.toString();
        request.agencyId = to.params.agencyid;
        await AppModule.loginAnon(request);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        await ContactAnonModule.getOfferConfirmation(to.params.jobworkerofferid);
        if (ContactAnonModule.isError) {
          return next({
            name: PageNames.ContactError.toString(),
          });
        }
        return next();
      }
      return next();
    }
    // Handle public auth pages that don't need navigation scope processing
    if (to.name === PageNames.EntraCallback.toString()) {
      return next();
    }
    // If we reach here, something unexpected happened - redirect to login for safety
    console.warn('Router: Unhandled navigation to', to.name, '- redirecting to login');
    return next({ path: '/login' });
  }
});

export default router
